
<template>  
    <!-- <transition name="component-fade" mode="out-in"> -->
        <!-- <keep-alive> -->
            <router-view></router-view>  
        <!-- </keep-alive>  -->
    <!-- </transition>  -->
</template>



<script lang="ts">
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "MilitarIndex",
        components: {    },  
    }) 
    export default class MilitarIndex extends Vue {
         
    }
  
</script>
 
 
<style lang="scss"> 

    
</style>

  